import React from 'react';
import styled from 'styled-components';

import { color as colors } from '@workboard/wobo-ui';

import CopyClip from '../common/CopyClip';

import BreadcrumbsIcon from './Icon';

import type { ITextProps } from '../../types/teams.types';

const TextWrapper = styled.span`
  color: ${colors('--gray-600')};
  display: inline-flex;
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing(0.5)}px;
  min-width: 0;
  min-height: ${({ theme }) => theme.spacing(4)}px;
  white-space: nowrap;
  cursor: default;

  svg {
    padding: 2px;
  }

  button {
    svg {
      padding: 0px;
    }
  }

  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:hover,
  &:focus-within,
  &:focus {
    button {
      opacity: 1;
    }
  }
`;

const Text = ({ name, iconType }: ITextProps): JSX.Element => {
  const textLength = name.length > 50;
  return (
    <TextWrapper>
      <BreadcrumbsIcon type={iconType} />
      <span {...(textLength && { title: name })}>{name}</span>
      <CopyClip pathname={window.location.href} width={32} height={20} />
    </TextWrapper>
  );
};

export default Text;
